export function initTabs() {
  document.querySelectorAll('[data-tabs]').forEach(container => {
    const tabs = container.querySelectorAll('[data-tab]');
    const panels = container.querySelectorAll('[data-tab-panel]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;

        tabs.forEach(t => {
          t.classList.remove('tab-btn-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('tab-btn-active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(panel => {
          if (panel.dataset.tabPanel === target) {
            panel.classList.remove('hidden');
          } else {
            panel.classList.add('hidden');
          }
        });

        if (history.replaceState) {
          history.replaceState(null, '', `#${target}`);
        }
      });
    });

    const hash = window.location.hash.slice(1);
    if (hash) {
      const hashTab = container.querySelector(`[data-tab="${hash}"]`);
      if (hashTab) hashTab.click();
    }
  });
}
